import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';
import { trimAndStrip } from '../../utilities/stringUtils';

export function requestAttributes() {
  return {
    type: Constants.REQUEST_ATTRIBUTES
  };
}
export function receiveAttributes(json, error) {
  return {
    type: Constants.RECEIVE_ATTRIBUTES,
    data: json,
    error
  };
}

export function requestSaveAttribute(mode, attribute) {
  return () => {
    return {
      type: Constants.REQUEST_SAVE_ATTRIBUTES,
      mode,
      attribute
    };
  };
}

export function receiveSaveAttribute(mode, attribute) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_SAVE_ATTRIBUTES,
      mode,
      data: json,
      error,
      attribute
    };
  };
}

export function updateAttributeFilter(filter) {
  return {
    type: Constants.UPDATE_ATTRIBUTE_FILTER,
    filter
  };
}

export function getAttributes(options = {}) {
  const path = 'ecs/api/attribute';
  return new Endpoint(path, requestAttributes, receiveAttributes)
    .withOptions(options)
    .call();
}

// Trims values, removes empty/nil values, removes duplicate values, sets type = 'AssetAttribute'
export function cleanAssetAttribute(attribute) {
  const cleaned = { ...attribute };
  cleaned.name = (attribute.name || '').trim();
  cleaned.values = [...new Set(trimAndStrip(attribute.values))];
  cleaned.type = 'AssetAttribute';
  return cleaned;
}

export function cleanWeatherAttribute(attribute) {
  const cleaned = { ...attribute };
  cleaned.name = (attribute.name || '').trim();
  cleaned.allow_new = false;

  if (attribute.values) {
    cleaned.values = [...new Set(trimAndStrip(attribute.values))];
  }

  if (cleaned.details?.forecast_ranges) {
    cleaned.details.forecast_ranges = cleaned.details.forecast_ranges.map(
      range => {
        // look for greaterThan/lessThan fields and make sure their values are ints
        for (const key in range) {
          if (key.endsWith('Than')) {
            range[key] = parseInt(range[key]);
          }
        }

        return range;
      }
    );
  }

  return cleaned;
}

export function saveAttribute(attribute, options = {}) {
  let cleanedAttribute = {};

  if (attribute.type?.startsWith('Weather')) {
    cleanedAttribute = cleanWeatherAttribute(attribute);
  } else {
    cleanedAttribute = cleanAssetAttribute(attribute);
  }

  let path = 'ecs/api/attribute';
  let mode = 'create';
  if (cleanedAttribute.uuid) {
    path += `/${cleanedAttribute.uuid}`;
    mode = 'edit';
  }
  return new Endpoint(
    path,
    requestSaveAttribute(mode, cleanedAttribute),
    receiveSaveAttribute(mode, cleanedAttribute)
  )
    .withMethod('POST')
    .withBody(JSON.stringify(cleanedAttribute))
    .withOptions(options)
    .call();
}

export function deleteAttribute(attribute, options = {}) {
  const path = `ecs/api/attribute/${attribute.uuid}`;
  return new Endpoint(
    path,
    requestSaveAttribute('delete', attribute),
    receiveSaveAttribute('delete', attribute)
  )
    .withMethod('DELETE')
    .withOptions(options)
    .call();
}
